/**
 * Maps normalized connectivity to LSQ `networkType`.
 * Returns `null` when offline, unknown transport, or anything other than Wi‑Fi / cellular / Ethernet
 * so the lead omits `networkType`.
 */
export function mapConnectivityToLsqNetworkType(isConnected, transport) {
    const t = (transport ?? "").trim().toLowerCase();
    if (isConnected === false || t === "none") {
        return null;
    }
    if (t === "wifi") {
        return "Wi-Fi";
    }
    if (t === "cellular") {
        return "Mobile";
    }
    if (t === "ethernet") {
        return "Ethernet";
    }
    return null;
}
